var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback } from 'react';
import { useUserDetailApi } from '../../../hooks';
import { useFamilyMemberComposer } from '../useFamilyMemberComposer.facade';
import { useUpdateFamilyApi } from '../../../hooks';
export var useUpdateProfileHelper = function (_a) {
    var isFamilyMember = _a.isFamilyMember, person = _a.person, customer = _a.customer, callFamilyUpdateApi = _a.callFamilyUpdateApi, confirmAlert = _a.confirmAlert;
    var _b = useUserDetailApi(), createPerson = _b.createPerson, updatePerson = _b.updatePerson;
    var updateFamily = useUpdateFamilyApi().updateFamily;
    var _c = useFamilyMemberComposer(), setProfile = _c.setProfile, resetProfile = _c.resetProfile;
    var callUpdateFamily = useCallback(function (profileParams) { return __awaiter(void 0, void 0, void 0, function () {
        var height, growthSpeed, allergies, ingredients, otherProfileFields, allergiesToAdd, excludedIngredients;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!callFamilyUpdateApi || !(person === null || person === void 0 ? void 0 : person.familyId)) {
                        return [2 /*return*/];
                    }
                    height = profileParams.height, growthSpeed = profileParams.growthSpeed, allergies = profileParams.allergies, ingredients = profileParams.ingredients, otherProfileFields = __rest(profileParams, ["height", "growthSpeed", "allergies", "ingredients"]);
                    allergiesToAdd = allergies === null || allergies === void 0 ? void 0 : allergies.map(function (a) {
                        return a.Ingredient.id;
                    });
                    excludedIngredients = ingredients === null || ingredients === void 0 ? void 0 : ingredients.map(function (a) {
                        return a.Ingredient.id;
                    });
                    return [4 /*yield*/, updateFamily(__assign(__assign({}, otherProfileFields), { familyId: person.familyId, height: Number(height), growthSpeed: growthSpeed !== null && growthSpeed !== void 0 ? growthSpeed : undefined, allergies: allergiesToAdd, ingredients: excludedIngredients }))];
                case 1:
                    _a.sent();
                    resetProfile();
                    return [2 /*return*/];
            }
        });
    }); }, [callFamilyUpdateApi, person === null || person === void 0 ? void 0 : person.familyId, resetProfile, updateFamily]);
    var saveProfile = useCallback(function (property) {
        return new Promise(function (resolve, reject) {
            setProfile(__assign({}, property), function (profile) { return __awaiter(void 0, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, callUpdateFamily(profile)];
                        case 1:
                            _a.sent();
                            resolve(null);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            // propago errore verso updateProfile
                            reject(error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        });
    }, [callUpdateFamily, setProfile]);
    var updateProfile = useCallback(function (newProfile, onSuccess) { return __awaiter(void 0, void 0, void 0, function () {
        var allergies, excludedIngredients, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 8, , 9]);
                    if (!confirmAlert) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirmAlert()];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (!isFamilyMember) return [3 /*break*/, 4];
                    return [4 /*yield*/, saveProfile(newProfile)];
                case 3:
                    _c.sent();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    return [2 /*return*/];
                case 4:
                    allergies = (_a = newProfile.allergies) === null || _a === void 0 ? void 0 : _a.map(function (a) {
                        return a.Ingredient.id;
                    });
                    excludedIngredients = (_b = newProfile.ingredients) === null || _b === void 0 ? void 0 : _b.map(function (a) {
                        return a.Ingredient.id;
                    });
                    if (!!(customer === null || customer === void 0 ? void 0 : customer.personId)) return [3 /*break*/, 6];
                    return [4 /*yield*/, createPerson(__assign(__assign({}, newProfile), { allergies: allergies, ingredients: excludedIngredients }))];
                case 5:
                    _c.sent();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    return [2 /*return*/];
                case 6:
                    if (!(person === null || person === void 0 ? void 0 : person.id)) {
                        throw new Error('Generic error');
                    }
                    return [4 /*yield*/, updatePerson(__assign(__assign({}, newProfile), { allergies: allergies, ingredients: excludedIngredients, id: person.id }))];
                case 7:
                    _c.sent();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    return [3 /*break*/, 9];
                case 8:
                    error_2 = _c.sent();
                    console.debug('[useUpdateProfileHelper] Aggiornamento profilo interrotto.', error_2);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [
        confirmAlert,
        createPerson,
        customer === null || customer === void 0 ? void 0 : customer.personId,
        isFamilyMember,
        person === null || person === void 0 ? void 0 : person.id,
        saveProfile,
        updatePerson,
    ]);
    return { updateProfile: updateProfile };
};
